import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  cinemas: [],
};
const cinemasSlice = createSlice({
  name: "cinemas",
  initialState,
  reducers: {
    /**Add a cinema to the store
     * @param {object} action
     * @param {object} action.payload the cinema to add
     */
    addCinema: (state, action) => {
      state.cinemas.push(action.payload);
    },
    /**Set the cinemas in the store
     * @param {object} action
     * @param {object} action.payload the cinemas to set
     */
    setCinemas: (state, action) => {
      state.cinemas = action.payload;
    },
  },
});
export const { addCinema, setCinemas } = cinemasSlice.actions;
export default cinemasSlice.reducer;
